import React, { useEffect, useState } from "react";
import PlantillaScreen from '../../../helpers/PlantillaScreen'
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useBox } from "../../../Finanzas/Helper/useBox";
import { GetKey } from "../../../Finanzas/Actions/GetContainer";
import { LoaderScreen } from "../../../components/LoaderScreen";
import Swal from "sweetalert2";
import { capitalizePalabras } from "../../../../Helpers/CapitalizePalabras";
import request from "../../../../Helpers/API";
import { GetMonthNameByNumber } from "../../../Finanzas/Helper/GetMonthNameByNumber";
import { AgregarPaqueteModal } from "./AgregarPaqueteModal";
import { EditarPaqueteModal } from "./EditarPaqueteModal";
import { ListadoPreciosModal } from "./ListadoPreciosModal";
import Settings from "@mui/icons-material/Settings";
import EditIcon from '@mui/icons-material/Edit';
import { AñadirPrecioMantenimientoModal } from "./AñadirPrecioMantenimientoModal";
import { EditarPrecioMantenimientoModal } from "./EditarPrecioMantenimientoModal";
import { FormatMoney } from "../../../../Helpers/FormatNumber";

export const ListadoPreciosMantenimientoScreen = () => {
    const history = useHistory();
    const { state } = useLocation();
    const { id_paquete, paquete } = state || {};
    const [openModal, setOpenModal] = useState(false);
    const [openModalEditar, setOpenModalEditar] = useState(false);
    const [precios, setPrecios] = useState();
    const [precioSelect, setPrecioSelect] = useState();
    const [modeloSelect, setModeloSelect] = useState();

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const handleOpenModal = () => {
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const handleOpenModalEditar = (id_precio, modelo) => {
        setPrecioSelect(id_precio);
        setModeloSelect(modelo);
        setOpenModalEditar(true);
    };

    const handleCloseModalEditar = () => {
        setPrecioSelect(0);
        setModeloSelect('');
        setOpenModalEditar(false);
    };

    useEffect(() => {
        onExecute();
    }, []);
    
    useEffect(() => {
        if (!openModal && !openModalEditar) {
            onExecute();
        }
    }, [openModal, openModalEditar]);

    const onExecute = () => {
        setLoader({ ...loader, mostrar: true });
        return new Promise((resolve, reject) => {
            setLoader({ ...loader, mostrar: true });
            request
                .get(
                    `DashboardPostventa/GetPreciosMantenimiento?id_paquete=${id_paquete}`
                )
                .then((result) => {
                    setLoader({ ...loader, mostrar: false });
                    setPrecios(result);
                    return;
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    reject(error);
                    return;
                });
        });
    };

    // console.log(precios)

    return (
        <PlantillaScreen
            titulo={`LISTADO DE PRECIOS DEL PAQUETE ` + (paquete?.toUpperCase() ?? "")}
            className={"configuracion-mantenimiento-main-screen"}
            className_main={2}
        >
            <LoaderScreen loader={loader} />
            <div className="configuracion-mantenimiento-actions">
                <div
                    className="configuracion-mantenimiento-actions-regresar"
                    onClick={() => history.goBack()}
                >
                    <ArrowBackIcon /> Regresar
                </div>
                <div className="buttons">
                    <button
                        className="configuracion-mantenimiento-header-configuracion"
                        onClick={() => handleOpenModal()}
                    >
                        <Settings /> Agregar precio
                    </button>
                </div>
            </div>
            <div className="configuracion-mantenimiento-header-info">
                <div className="contador-configuracion-mantenimiento-encontrados">
                    Precios disponibles: {precios?.length}
                </div>
            </div>
            {precios && precios.length > 0 && (
                <div className="configuracion-mantenimiento">
                    <div className="configuracion-mantenimiento-container scroll">
                        <table cellPadding={0} cellSpacing={0}>
                            <thead>
                                <tr>
                                    <th>Modelo</th>
                                    <th>
                                        <div>Precio</div>
                                    </th>
                                    <th>
                                        <div>Opciones</div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {precios.map((item, index) => (
                                    <tr key={item.id_precio}>
                                        <td>{item.modelo}</td>
                                        <td className="ta-center">{FormatMoney(item.precio)}</td>
                                        <td className="celda-opciones">
                                            <div className="paquetes-acciones-listado">
                                                <div
                                                    className="boton-editar-paquetes"
                                                    onClick={() =>
                                                        handleOpenModalEditar(item.id_precio, item.modelo)
                                                    }
                                                >
                                                    <EditIcon /> Editar
                                                </div>
                                            </div>

                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
            <AñadirPrecioMantenimientoModal
                open={openModal}
                onClose={handleCloseModal}
                id_paquete={id_paquete}
            />
            <EditarPrecioMantenimientoModal
                open={openModalEditar}
                onClose={handleCloseModalEditar}
                id_precio={precioSelect}
                id_paquete={id_paquete}
            />
        </PlantillaScreen>
    )
}
